import React from "react";
import Checkout4 from "../components/Checkout4";

const checkout4 = () => {
  return <Checkout4 />;
};

export default checkout4;
